import _ from "lodash";
import { useCallback } from "react";
import { Box, Card } from "@mui/material";
import Button from "../../../toolkit/ButtonV1";
import FormControl from "../../../components/FormControl";
import { useState } from "react";
import { useEffect } from "react";
import Upload from "../../../icons/Upload";

import fileDownload from 'js-file-download'
import { CSVLink } from "react-csv";
import axios from "../../../utils/fvAxios";
import GetfVDateFormate from "../../../utils/Genaricfunctions";
// import upload from "../../../Media/Upload.jpeg";
import "../../../Localization/i18n";
import { useTranslation } from "react-i18next";

const searchDebounceDelay = 1000;

export default function ({
  searchStr: parentSearchStr,
  setSearchStr: parentSetSearchStr,
  IsDownload
}) {
  const [searchStr, setSearchStr] = useState(parentSearchStr);
  const debouncedSearchQueryHandler = useCallback(
    _.debounce(parentSetSearchStr, searchDebounceDelay),
    []
  );
  const { t } = useTranslation();
  useEffect(() => {
    if (parentSearchStr !== searchStr) {
      debouncedSearchQueryHandler(searchStr);
    }
  }, [searchStr]);

  const headers = [
    { label: "VendorName", key: "vendorName" },
    { label: "DocumentTypeName", key: "documentTypeName" },
    { label: "Status", key: "vendorStatus" },
    { label: "ClientName", key: "clientName" },
    { label: "DateUploaded", key: "dateUploaded" },
    { label: "ExpirationDate", key: "expirationDate" }
  ]
  function convertToCSV(data) {
    const header = headers.map(header => `"${header.label}"`).join(',');
    const rows = data?.map(item =>
        headers.map(header => `"${item[header.key]}"`).join(',')
    );

    return [header, ...rows].join('\n');
}

  const [download, setDownload] = useState(null);

  const handleDownload = () => {
    axios.get(IsDownload + "&isDownload=" + true)
      .then((res) => {
        setDownload(res?.data?.data);
        if (res.data.data) {
          const csvContent = convertToCSV(res?.data?.data);
          const blob = new Blob([csvContent], { type: 'text/csv' });
          const url = URL.createObjectURL(blob);

          const a = document.createElement('a');
          a.href = url;
          a.download = 'Recent Documents.csv';
          a.click();
          URL.revokeObjectURL(url);
        }
      })
      .catch((error) => {
        //console.error('API request failed:', error);
      })
  }

  return (
    <Box className="collection-controls">
      <FormControl
        inputType="text"
        placeholder="Search"
        value={searchStr}
        handleChange={setSearchStr}
      />
      <div style={{ marginLeft: "auto" }}> <Card onClick={handleDownload} sx={{ cursor: "pointer", padding: "5px" }}>{t("DashboardAnalytics.exporttoExcel")}</Card></div>

    </Box>
  );
}
